import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const ABVentures = (props) => {
  // ratio: width: 540, height: 650
  const data = useStaticQuery(graphql`
    query {
      file(
        relativePath: {
          eq: "components/pages/AboutPage/Sections/InvestorsSection/images/ab-ventures.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 405, maxHeight: 488, trim: 0.1, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return <Img fluid={data.file.childImageSharp.fluid} {...props} />
}

export default ABVentures
